module.exports = __webpack_public_path__ + "static/media/students.169926c1.svg";